import DeviationPaywallContainer from './DeviationPaywall.container';
import DeviationPaywall from './DeviationPaywall';
export default DeviationPaywallContainer(DeviationPaywall);
